import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import { useEffect, useState } from 'react';

export default function HomePage() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    'https://static.readdy.ai/image/e7596bc6af9def0d5965eecdb80c30c5/f09c9594e7afa57e16852f170b91649f.png',
    'https://static.readdy.ai/image/e7596bc6af9def0d5965eecdb80c30c5/3f4a89d0cf3a9921bc2fe5f21f9f3b1e.png',
    'https://static.readdy.ai/image/e7596bc6af9def0d5965eecdb80c30c5/cfb1b54e2d2c57d6c1558d4637f58c02.jpeg'
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Add Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Exalt Ventures Ltd.",
      "url": import.meta.env.VITE_SITE_URL || "https://exaltventures.com",
      "logo": "https://static.readdy.ai/image/e7596bc6af9def0d5965eecdb80c30c5/958896c59990a954abb8a56c1852741e.png",
      "description": "Master franchise and retail operating group managing international fashion brands across Libya, Algeria, and Malta since 2007.",
      "foundingDate": "2007",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Tripoli",
        "addressCountry": "LY"
      },
      "areaServed": ["Libya", "Algeria", "Malta"],
      "brand": [
        {
          "@type": "Brand",
          "name": "Monsoon Children"
        },
        {
          "@type": "Brand",
          "name": "Accessorize"
        },
        {
          "@type": "Brand",
          "name": "Dune London"
        }
      ]
    });
    document.head.appendChild(script);
    
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Navigation />

      {/* Hero Section */}
      <header className="relative h-[60vh] sm:h-[70vh] flex items-center justify-center bg-white overflow-hidden">
        <div className="absolute inset-0">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img 
                src={slide}
                alt={`Hero Background ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-serif text-white mb-4 sm:mb-6 leading-tight drop-shadow-lg">
            International Brand Franchise Operator
          </h1>
          <p className="text-sm sm:text-base text-white mb-6 sm:mb-10 leading-relaxed max-w-2xl mx-auto drop-shadow-md px-4">
            Operating established international fashion brands across Libya, Algeria, and Malta with excellence and sophistication.
          </p>
          <Link 
            to="/brands" 
            className="inline-block px-6 sm:px-10 py-2.5 sm:py-3 border-2 border-white text-white text-xs font-semibold tracking-wide hover:bg-white hover:text-[#003264] transition-all duration-300 whitespace-nowrap"
          >
            EXPLORE OUR BRANDS
          </Link>
        </div>
      </header>

      {/* Overview */}
      <section className="py-12 sm:py-16 md:py-20 bg-[#FAFAFA]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-sm sm:text-base text-[#003264] leading-relaxed">
              Exalt Ventures Ltd. is a distinguished master franchise and retail operating group managing renowned international fashion brands across multiple territories, delivering exceptional retail experiences since 2007.
            </p>
          </div>
        </div>
      </section>

      {/* Brands Snapshot */}
      <section className="py-12 sm:py-16 md:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl sm:text-3xl font-serif text-[#003264] text-center mb-10 sm:mb-16">Our Brand Portfolio</h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 md:gap-12 max-w-6xl mx-auto">
            <article className="bg-[#FAFAFA] p-6 sm:p-8 md:p-10 text-center hover:shadow-lg transition-shadow duration-300">
              <div className="w-full h-32 sm:h-36 md:h-40 mb-4 sm:mb-6 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/e7596bc6af9def0d5965eecdb80c30c5/b524f0feb747033f02bc4cc72cf4091d.png" 
                  alt="Monsoon Children"
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-lg sm:text-xl font-serif text-[#003264] mb-2 sm:mb-3">Monsoon Children</h3>
              <p className="text-xs sm:text-sm text-[#003264] leading-relaxed">Monsoon Children pieces are crafted resourcefully and thoughtfully with close attention to fabrication, detail, quality and comfort to make heirlooms that can be handed down through the generations. And truly delight in the detail!</p>
            </article>
            <article className="bg-[#FAFAFA] p-6 sm:p-8 md:p-10 text-center hover:shadow-lg transition-shadow duration-300">
              <div className="w-full h-32 sm:h-36 md:h-40 mb-4 sm:mb-6 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/e7596bc6af9def0d5965eecdb80c30c5/67edc3f3e7155edd16a4df0f7ac87263.jpeg" 
                  alt="Accessorize"
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-lg sm:text-xl font-serif text-[#003264] mb-2 sm:mb-3">Accessorize</h3>
              <p className="text-xs sm:text-sm text-[#003264] leading-relaxed">Born in 1984, Accessorize is the original destination for everyday accessories with an eclectic twist. With more than 300 stores globally, the brand is determined to carry on making differences in big ways and small.</p>
            </article>
            <article className="bg-[#FAFAFA] p-6 sm:p-8 md:p-10 text-center hover:shadow-lg transition-shadow duration-300">
              <div className="w-full h-32 sm:h-36 md:h-40 mb-4 sm:mb-6 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/e7596bc6af9def0d5965eecdb80c30c5/e4116a73f104493211a0b3ea83325af0.jpeg" 
                  alt="Dune London"
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-lg sm:text-xl font-serif text-[#003264] mb-2 sm:mb-3">Dune London</h3>
              <p className="text-xs sm:text-sm text-[#003264] leading-relaxed">Born in 1992 to generations of shoe manufacturers, the founder Daniel Rubin was destined to follow in their footsteps with a shoe empire of his own. The dream was simple - to create an affordable luxury footwear and accessories brand. The brand is present worldwide with over 350 store locations - London born, globally worn.</p>
            </article>
          </div>
        </div>
      </section>

      {/* Markets Snapshot */}
      <section className="py-12 sm:py-16 md:py-20 bg-[#FAFAFA]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl sm:text-3xl font-serif text-[#003264] text-center mb-10 sm:mb-16">Our Markets</h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 md:gap-10 max-w-5xl mx-auto">
            <article className="group cursor-pointer">
              <div className="w-full h-48 sm:h-52 md:h-56 mb-4 sm:mb-5 overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/e7596bc6af9def0d5965eecdb80c30c5/44ed167e3b7a8d9a6559f5dab31e22c3.jpeg" 
                  alt="Libya Market"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <h3 className="text-lg sm:text-xl font-serif text-[#003264] text-center mb-2">Libya – Tripoli</h3>
            </article>
            <article className="group cursor-pointer">
              <div className="w-full h-48 sm:h-52 md:h-56 mb-4 sm:mb-5 overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/e7596bc6af9def0d5965eecdb80c30c5/631696ec6a108e88f84bf41869546a98.jpeg" 
                  alt="Algeria Market"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <h3 className="text-lg sm:text-xl font-serif text-[#003264] text-center mb-2">Algeria – Algiers &amp; Oran</h3>
            </article>
            <article className="group cursor-pointer">
              <div className="w-full h-48 sm:h-52 md:h-56 mb-4 sm:mb-5 overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/e7596bc6af9def0d5965eecdb80c30c5/2a5ca79776a3ad8a880fd08251689b12.webp" 
                  alt="Malta Market"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <h3 className="text-lg sm:text-xl font-serif text-[#003264] text-center mb-2">Malta – Sliema Fgura Mosta Qormi</h3>
            </article>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-12 sm:py-16 md:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl font-serif text-[#003264] mb-4 sm:mb-6">Discover Excellence in Retail</h2>
            <p className="text-sm sm:text-base text-[#003264] mb-6 sm:mb-10 leading-relaxed">
              Learn more about our commitment to bringing world-class fashion brands to discerning customers across North Africa and Malta.
            </p>
            <Link 
              to="/about" 
              className="inline-block px-6 sm:px-10 py-2.5 sm:py-3 bg-[#003264] text-white text-xs font-semibold tracking-wide hover:bg-[#003264]/90 transition-all duration-300 whitespace-nowrap"
            >
              ABOUT EXALT VENTURES
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
